(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const init = () => {
    document.querySelectorAll('[data-mc-carousel]').forEach(carousel => {
      if (carousel.dataset.editorialBound) return;
      carousel.dataset.editorialBound = 'true';
      const track = carousel.querySelector('[data-mc-track]');
      if (!track || !track.children.length) return;
      const move = direction => {
        const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        const step = track.children[0].getBoundingClientRect().width + gap;
        let target = track.scrollLeft + direction * step;
        if (direction > 0 && target > track.scrollWidth - track.clientWidth + 10) target = 0;
        if (direction < 0 && target < -10) target = track.scrollWidth - track.clientWidth;
        track.scrollTo({left: target, behavior: reduced.matches ? 'instant' : 'smooth'});
      };
      carousel.querySelector('[data-mc-prev]')?.addEventListener('click', () => move(-1));
      carousel.querySelector('[data-mc-next]')?.addEventListener('click', () => move(1));
      const period = Number(carousel.dataset.mcAuto);
      if (period) setInterval(() => {
        const rect = carousel.getBoundingClientRect();
        if (!reduced.matches && !document.hidden && !carousel.matches(':hover,:focus-within') && rect.bottom > 0 && rect.top < innerHeight) move(1);
      }, period);
    });
    document.querySelectorAll('[data-mc-reviews]').forEach(viewport => {
      if (viewport.dataset.editorialBound) return;
      viewport.dataset.editorialBound = 'true';
      const track = viewport.firstElementChild;
      let previous = 0;
      const animate = time => {
        if (previous && !reduced.matches && !document.hidden && !viewport.matches(':hover,:focus-within')) {
          viewport.scrollLeft += Math.min(time - previous, 50) * 0.025;
          const half = track.children[Math.floor(track.children.length / 2)].offsetLeft - track.children[0].offsetLeft;
          if (viewport.scrollLeft >= half) viewport.scrollLeft -= half;
        }
        previous = time;
        requestAnimationFrame(animate);
      };
      requestAnimationFrame(animate);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
